import script from "./DnsRecordsResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./DnsRecordsResults.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__